import React from 'react';
import CreateProductNew from '../pages/CreateProductNew';
import useUploadStore from '../stores/uploadStore';

const CreateProductDialog = () => {
  const { isCreateProductModalOpen, closeCreateProductModal, droppedImages, clearDroppedImages } = useUploadStore();

  const handleClose = () => {
    closeCreateProductModal();
    clearDroppedImages();
  };

  if (!isCreateProductModalOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[9000] overflow-y-auto"
      style={{ backgroundColor: 'var(--chrome-bg, #fff)' }}
    >
      <div className="relative">
        <button
          onClick={handleClose}
          className="absolute right-2 top-2 z-10 p-2 rounded-full bg-[var(--surface)] hover:bg-[var(--surface-container)] transition-colors shadow"
          aria-label="Close"
        >
          <span className="material-symbols-outlined text-on-surface-variant">close</span>
        </button>
        <CreateProductNew
          isModal={true}
          initialImages={droppedImages}
          onClose={handleClose}
        />
      </div>
    </div>
  );
};

export default CreateProductDialog;